module.exports = __webpack_public_path__ + "market/static/img/egg2.f5e5afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/egg2.png
// module id = tE/i
// module chunks = 1